import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { MARGIN_GAP } from "../../lib/constants.js";

export default function FeedbackDialog({
  actionButtonText,
  bodyPrimary,
  bodySecondary,
  closeButtonText,
  icon: Icon,
  iconColor,
  locales,
  onActionClick,
  onClose,
  show,
  title,
}) {
  return (
    <Dialog open={show}>
      {Icon ? (
        <Box display="flex" justifyContent="center" mt={MARGIN_GAP}>
          <Icon color={iconColor || "secondary"} fontSize="large" />
        </Box>
      ) : null}
      {title ? (
        <DialogTitle component="h2" variant="h6" align="center" gutterBottom>
          {title}
        </DialogTitle>
      ) : null}
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {bodyPrimary ? (
          <DialogContentText color="text.primary">
            {bodyPrimary}
          </DialogContentText>
        ) : null}
        {bodySecondary ? (
          <DialogContentText color="text.primary">
            {bodySecondary}
          </DialogContentText>
        ) : null}
      </DialogContent>
      <DialogActions sx={{ display: "flex", justifyContent: "space-around" }}>
        {actionButtonText && onActionClick ? (
          <Button onClick={onActionClick} color="secondary" size="large">
            {actionButtonText}
          </Button>
        ) : null}
        <Button
          onClick={onClose}
          color={actionButtonText && onActionClick ? "primary" : "secondary"}
          size="large"
        >
          {closeButtonText || locales["button.close"]}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
